/**
 * Visibility пунктов inline-меню таблицы после onInlineMenuShow.
 * Порядок как в ElementRenderer.isTableInlineActionVisible:
 * snapshot меню → deferred setVisible("action",…) → registry MAction → true.
 */
export function resolveTableInlineActionVisible(options: {
  fromMenu?: boolean
  deferred?: boolean
  registryVisible?: boolean
}): boolean {
  if (options.fromMenu !== undefined) return options.fromMenu
  if (options.deferred !== undefined) return options.deferred
  if (options.registryVisible !== undefined) return options.registryVisible
  return true
}

/** Ids layout.position=inline для сброса stale deferred перед onInlineMenuShow. */
export function collectInlineActionIds(actions: Array<{ _attributes?: { id?: unknown }; id?: unknown }>): string[] {
  const ids: string[] = []
  for (const action of actions) {
    const actionId = String(action?._attributes?.id ?? action?.id ?? '').trim()
    if (actionId) ids.push(actionId)
  }
  return ids
}

/**
 * Собирает map visibility из deferred peek для текущего списка inline-actions.
 * Вызывается на каждый show меню — без «залипания» предыдущего false.
 */
export function buildTableInlineActionVisibilityMap(
  actionIds: Array<string | number>,
  peekDeferred: (actionId: string | number) => boolean | undefined,
): Record<string, boolean> {
  const next: Record<string, boolean> = {}
  for (const rawId of actionIds) {
    const actionId = String(rawId ?? '').trim()
    if (!actionId) continue
    const deferred = peekDeferred(actionId)
    if (deferred !== undefined) {
      next[actionId] = deferred
    }
  }
  return next
}
